'use client'

import { Droplet, Fuel } from 'lucide-react'
import type { FuelType } from '@/lib/types'
import { cn } from '@/lib/utils'

interface FuelTypeToggleProps {
	value: FuelType
	onChange: (f: FuelType) => void
}

export function FuelTypeToggle({ value, onChange }: FuelTypeToggleProps) {
	return (
		<fieldset>
			<legend className="mb-2 block text-xs font-medium text-text-secondary">Fuel Type</legend>
			<div className="flex rounded-lg border border-border bg-surface p-0.5">
				<button
					type="button"
					onClick={() => onChange('diesel')}
					className={cn(
						'flex flex-1 items-center justify-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-all',
						value === 'diesel'
							? 'bg-brand text-white'
							: 'text-text-secondary hover:text-text-primary',
					)}
				>
					<Fuel className="size-3.5" />
					Diesel
				</button>
				<button
					type="button"
					onClick={() => onChange('gas')}
					className={cn(
						'flex flex-1 items-center justify-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-all',
						value === 'gas' ? 'bg-brand text-white' : 'text-text-secondary hover:text-text-primary',
					)}
				>
					<Droplet className="size-3.5" />
					Gas
				</button>
			</div>
		</fieldset>
	)
}
